<template>
    <!-- 银行 -->
    <div id="bankDiv" class="wrap">
        <el-dialog :visible.sync="bankDivVisible" 
        :before-close="bank_dialog_close" v-loading="loading"
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading">
            <div class="itembg">
                <center><font color="ff0000" class="title">国立中央银行总行</font></center><hr color="000000">
                <div v-if="null != fantasyBankAccount && '{}' != JSON.stringify(fantasyBankAccount)" id="fantasyBankAccount">
                    <div class="currentBalance">
                        余额：{{fantasyBankAccount.currentBalance}}
                    </div>
                    <el-button type="primary" plain size="mini" @click="showSaveMoney();">存款</el-button>
                    <el-button type="primary" plain size="mini" @click="showWithdrawMoney();">取款</el-button>
                    <el-button type="primary" plain size="mini" @click="showTransferMoney();">转账</el-button>
                    <el-button type="primary" plain size="mini" @click="showAccountFlow();">记录</el-button>
                </div>
                <div style="margin:10px;" v-if="'{}' == JSON.stringify(fantasyBankAccount)">
                    <el-button type="primary" plain size="mini" @click="createBankAccount();">开户</el-button>
                </div>
                <div style="clear:both"></div>
          </div>
        </el-dialog>
        
        <!-- 存款div -->
        <el-dialog :visible.sync="saveMoneyDivVisible" 
        :before-close="save_money_dialog_close" v-loading="loading"
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading">
            <div class="itembg">
                <center><font color="ff0000" class="title">存款</font></center><hr color="000000">
                <div class="currentBalance">
                  <label>金额：</label>
                  <input type="number" v-myfocus v-model="saveAmount"/>
                </div>
                <el-button type="primary" plain size="mini" @click="saveMoney();">存入</el-button>
                <div style="clear:both"></div>
          </div>
        </el-dialog>

        <!-- 取款div -->
        <el-dialog :visible.sync="withdrawMoneyDivVisible" 
        :before-close="withdraw_money_dialog_close" v-loading="loading"
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading">
            <div class="itembg">
                <center><font color="ff0000" class="title">取款</font></center><hr color="000000">
                <div class="currentBalance">
                  <label>金额：</label>
                  <input type="number" v-myfocus v-model="withdrawAmount"/>
                </div>
                <el-button type="primary" plain size="mini" @click="withdrawMoney();">取出</el-button>
                <div style="clear:both"></div>
          </div>
        </el-dialog>

        <!-- 转账div -->
        <el-dialog :visible.sync="transferMoneyDivVisible" 
        :before-close="transfer_money_dialog_close" v-loading="loading"
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading">
            <div class="itembg">
                <center><font color="ff0000" class="title">转账</font><font color="ff0000">（手续费5%）</font></center><hr color="000000">
                <div class="currentBalance">
                  <label>用户名：</label>
                  <input type="text" v-myfocus v-model="transferTo"/>
                </div>
                <div class="currentBalance">
                  <label>金额：</label>
                  <input type="number" v-model="transferAmount"/>
                </div>
                <el-button type="primary" plain size="mini" @click="transferMoney();">转出</el-button>
                <div style="clear:both"></div>
          </div>
        </el-dialog>

        <!-- 交易记录 -->
        <el-dialog class="wrap" :visible.sync="accountFlowTableVisible" :before-close="account_flow_dialog_close"
         v-loading="loading"
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading">
            <div class="npcbg">
                <div class="npctitle">
                    交易记录
                </div>
                <div v-if="null != fantasyBankAccountFlowList" class="fantasyBankAccountFlowList">
                    <el-row>
                    <el-col :span="5"><span>类型</span></el-col>
                    <el-col :span="5"><span>金额</span></el-col>
                    <el-col :span="4"><span>费用</span></el-col>
                    <el-col :span="10"><span>交易时间</span></el-col>
                    </el-row>
                    <el-row v-for="flow in fantasyBankAccountFlowList" v-bind:key="flow.id" @click.native="showFlowDetail(flow)">
                        <el-col :span="5"><span :title="flow.flowTypeStr">{{flow.flowTypeStr}}</span></el-col>
                        <el-col :span="5"><span :title="flow.amount">{{flow.amount}}</span></el-col>
                        <el-col :span="4"><span :title="flow.charge">{{flow.charge}}</span></el-col>
                        <el-col :span="10"><span :title="flow.createTime">{{flow.createTime}}</span></el-col>
                    </el-row>
                    <div class="pageDiv">
                    <!-- 分页组件 -->
                    <Paging 
                        :name="name"
                        @change="onFlowPageChange"
                        :page-size="size"
                        :total="total"
                        layout="jumper,total"
                        :current-page="curPage"
                    />
                    </div>
                </div>
                <div class="noNpc" v-if="'[]' == JSON.stringify(fantasyBankAccountFlowList)">
                    未查询到交易记录
                </div>
                <div style="clear:both"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {getRequest} from '../../utils/api'
import {postRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
import Paging from '../../components/Paging';
export default {
  name: 'bank',
  components:{
    Paging
  },
  props:{
    bankDivVisible: {
      type: Boolean,
      default: false
    },
    fantasyUserBO: Object,
  },
  data() {
    return {
        fantasyBankAccount: null,
        loading: false,
        saveMoneyDivVisible: false,
        saveAmount: '',
        withdrawMoneyDivVisible: false,
        withdrawAmount: '',
        transferMoneyDivVisible: false,
        transferTo: '',
        transferAmount: '',
        accountFlowTableVisible: false,
        fantasyBankAccountFlowList: null,
        size:10,
        total:0,
        curPage:1,
    };
  },
  watch: {
    bankDivVisible: {
      handler(newVal) {
        if (newVal === true) {
          this.getBankAccount();
        }
      }
    }
  },
  mounted: function () {
      if (this.bankDivVisible) {
          this.getBankAccount();
      }
  },
  methods: {
    // 移动端点击后显示提示信息
    showTitle(value) {
        this.$notify({
            message: value,
            duration: 6000
        })
    },
    // 移动端点击行显示完整交易详情
    showFlowDetail(flow) {
        this.$alert(
            '类型：' + flow.flowTypeStr + '<br>' +
            '金额：' + flow.amount + '<br>' +
            '转出类型：' + flow.fromTypeStr + '<br>' +
            '转出方：' + flow.fromId + '<br>' +
            '转入类型：' + flow.toTypeStr + '<br>' +
            '转入方：' + flow.toId + '<br>' +
            '费用：' + flow.charge + '<br>' +
            '交易时间：' + flow.createTime,
            '交易详情',
            {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '关闭',
                closeOnClickModal: true,
                showClose: true
            }
        ).catch(function(){})
    },
    bank_dialog_close(){
      this.$emit("bank_dialog_close");
    },
    //银行
    getBankAccount: function(){
        this.fantasyBankAccount = null;
        this.loading = true;
        getRequest('/map/bank/getBankAccount', {
        }).then(resp=> {
          this.loading = false;
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              if (null != respData.data.fantasyBankAccount) {
                this.fantasyBankAccount = respData.data.fantasyBankAccount;
              } else {
                this.fantasyBankAccount = {};
              }
            } else {
              // 未开户是正常状态，不是错误：静默切到「开户」面板，不弹报错。
              // 注意必须把 fantasyBankAccount 置为 {}，因为它开头是 null，
              // 而「开户」按钮的条件是 '{}' == JSON.stringify(fantasyBankAccount)
              // （JSON.stringify(null) === 'null'），否则按钮不显示、玩家无路可走。
              if (respData.message && (respData.message.indexOf('开户') > -1 || respData.message.indexOf('不存在') > -1)) {
                this.fantasyBankAccount = {};
              } else {
                Message.error(respData.message);
              }
            }
          } else {
            //失败
            Message.error('查询银行账号失败');
          }
        }, resp=> {
          Message.error('查询银行账号异常');
        });
    },
    //开户
    createBankAccount: function(){
        this.fantasyBankAccount = null;
        this.loading = true;
        postRequest('/map/bank/createBankAccount', {
        }).then(resp=> {
          this.loading = false;
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              if (null != respData.data && null != respData.data.fantasyBankAccount) {
                this.fantasyBankAccount = respData.data.fantasyBankAccount;
              } else {
                this.fantasyBankAccount = {};
              }
            } else {
              Message.error(respData.message);
              // 开户失败时回到「未开户」态，否则 fantasyBankAccount 停在 null，
              // 余额面板与开户按钮都不显示，弹窗变成一片空白、无法重试。
              this.fantasyBankAccount = {};
            }
          } else {
            //失败
            Message.error('开户失败');
          }
        }, resp=> {
          Message.error('开户异常');
        });
    },
    showSaveMoney: function() {
      this.saveMoneyDivVisible = true;
    },
    save_money_dialog_close(){
      this.saveMoneyDivVisible = false;
      this.saveAmount = '';
    },
    saveMoney: function() {
        var _this = this;
        this.loading = true;
        postRequest('/map/bank/saveMoney', {
            amount: this.saveAmount
        }).then(resp=> {
          _this.loading = false;
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              Message.success(respData.message);
              if (null != respData.data && null != respData.data.fantasyBankAccount) {
                this.fantasyBankAccount = respData.data.fantasyBankAccount;
              } else {
                this.fantasyBankAccount = {};
              }
            } else {
              Message.error(respData.message);
            }
            _this.save_money_dialog_close();
          } else {
            //失败
            Message.error('存款失败');
          }
        }, resp=> {
          Message.error('存款异常');
        });
    },
    showWithdrawMoney: function() {
      this.withdrawMoneyDivVisible = true;
    },
    withdraw_money_dialog_close(){
      this.withdrawMoneyDivVisible = false;
      this.withdrawAmount = '';
    },
    withdrawMoney: function() {
        var _this = this;
        this.loading = true;
        postRequest('/map/bank/withdrawMoney', {
            amount: this.withdrawAmount
        }).then(resp=> {
          _this.loading = false;
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              Message.success(respData.message);
              if (null != respData.data && null != respData.data.fantasyBankAccount) {
                this.fantasyBankAccount = respData.data.fantasyBankAccount;
              } else {
                this.fantasyBankAccount = {};
              }
            } else {
              Message.error(respData.message);
            }
            _this.withdraw_money_dialog_close();
          } else {
            //失败
            Message.error('取款失败');
          }
        }, resp=> {
          Message.error('取款异常');
        });
    },
    
    showTransferMoney: function() {
      this.transferMoneyDivVisible = true;
    },
    transfer_money_dialog_close(){
      this.transferMoneyDivVisible = false;
      this.transferTo = '';
      this.transferAmount = '';
    },
    transferMoney: function() {
        var _this = this;
        this.loading = true;
        postRequest('/map/bank/transferMoney', {
            amount: this.transferAmount,
            transferTo: this.transferTo
        }).then(resp=> {
          _this.loading = false;
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              Message.success(respData.message);
              if (null != respData.data && null != respData.data.fantasyBankAccount) {
                this.fantasyBankAccount = respData.data.fantasyBankAccount;
              } else {
                this.fantasyBankAccount = {};
              }
            } else {
              Message.error(respData.message);
            }
            _this.transfer_money_dialog_close();
          } else {
            //失败
            Message.error('转账失败');
          }
        }, resp=> {
          Message.error('转账异常');
        });
    },
    
    onFlowPageChange:function(page){
      this.curPage = page.curPage;
      this.showAccountFlow();
    },
    showAccountFlow: function() {
      this.accountFlowTableVisible = true;
        var _this = this;
        this.loading = true;
        this.fantasyBankAccountFlowList = null;
        postRequest('/map/bank/listBankAccountFlow', {
            page: this.curPage
        }).then(resp=> {
          _this.loading = false;
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              if (null != respData.data && null != respData.data.fantasyBankAccountFlowPageInfo) {
                this.fantasyBankAccountFlowList = respData.data.fantasyBankAccountFlowPageInfo.list;
                this.total = respData.data.fantasyBankAccountFlowPageInfo.total;
                this.size = respData.data.fantasyBankAccountFlowPageInfo.pageSize;
                this.curPage = respData.data.fantasyBankAccountFlowPageInfo.pageNum;
              } else {
                this.fantasyBankAccountFlowList = [];
                this.total = respData.data.fantasyBankAccountFlowPageInfo.total;
                this.size = respData.data.fantasyBankAccountFlowPageInfo.pageSize;
                this.curPage = respData.data.fantasyBankAccountFlowPageInfo.pageNum;
              }
            } else {
              Message.error(respData.message);
            }
            _this.transfer_money_dialog_close();
          } else {
            //失败
            Message.error('转账失败');
          }
        }, resp=> {
          Message.error('转账异常');
        });
    },
    account_flow_dialog_close(){
      this.accountFlowTableVisible = false;
    },
  },
  beforeDestroy: function() {
  }
}
</script>

<style scoped>
a {
    cursor: pointer;
    color: blue;
}
.wrap {
    margin:auto;
    text-align: center;
}
.title {
    font-size: 2em;
    line-height: 2em;
}
.currentBalance {
    margin: 10px;
    height: 30px;
    line-height: 30px;
}
#propTypeEnumList {
}

#propTypeEnumList select {
    height: 30px;
    line-height: 30px;
}
#propTypeEnumList div {
    margin: 10px;
}
.itembg {
    width:80%;
    height:100%;
    height: 200px;
    text-align: center;
    margin: 0 auto;
}

/* ========== 移动端：交易记录 ========== */
@media screen and (max-width: 768px) {
  .itembg {
    width: 100%;
    height: auto;
    padding: 4px;
    box-sizing: border-box;
  }
  .title {
    font-size: 16px;
    line-height: 1.6;
  }
  .currentBalance {
    margin: 6px;
    height: 28px;
    line-height: 28px;
    font-size: 13px;
  }
  .currentBalance input {
    width: 100px;
  }
}
</style>
